import { useState, useEffect, useReducer } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

import { debounce } from "lodash";

import useAxios from "../services/useAxios";

import { translateToReactSelect } from "../utils/helperFunction";
import { mobileChecker } from "../utils/regexCheckers";

import { ReactSelect } from "../components/kits/Inputs/Inputs";
import CustomButton from "../components/kits/button/CustomButton";
import ToastCustomize from "../components/kits/ToastCustomize";

import OrderPageContent from "../components/create-order-page";
import AddEditCustomerModal from "../components/customer-list/customerModal/AddEditCustomerModal";

import Loader from "../utils/Loader";

import "../components/create-order-page/create-order-page-style.scss";

const ACTIONS = {
  ADD: "ADD",
  CHECK: "CHECK",
  CHANGEPUBLIC: "CHANGEPUBLIC",
  CHANGEITEM: "CHANGEITEM",
  SUBMIT: "SUBMIT",
  EDIT: "EDIT",
  CHANGERECI: "CHANGERECI",
  PROPERTY: "PROPERTY",
  REMOVE: "REMOVE",
  SETEDITDATA: "SETEDITDATA",
};

export default function CreateOrderPage() {
  const { typeId, orderId } = useParams();
  const route = useLocation();
  const navigate = useNavigate();
  const { execute: getHashtag } = useAxios("api/Find_tag");
  const { execute: findUser } = useAxios("api/Find_users");
  const { execute: getConfig } = useAxios("api2/get_configs");
  const { execute: customerListApi } = useAxios("product/get_customers");
  const { execute: productListApi } = useAxios("product/get_products");
  const { execute: addOrderApi } = useAxios("order/add_order");
  const { execute: editOrderApi } = useAxios("order/edit_order");
  const { execute: getOrderApi } = useAxios("order/get_orders");

  const reducer = (state, action) => {
    switch (action.type) {
      case ACTIONS.ADD:
        let addTemp = {
          title: "",
          id: -1,
          price: 0,
          call_price: typeId == 2 ? false : true,
          count: 0,
          discount: 0,
          options: [],
          added: true,
          custom_id:
            state?.items?.length == 0
              ? 1
              : state?.items[state?.items?.length - 1].custom_id + 1,
        };
        return { ...state, items: [...(state.items ?? []), addTemp] };
      case ACTIONS.CHECK:
        return "CHECK";
      case ACTIONS.CHANGEITEM:
        let itemTemp = {
          ...state,
          items: state.items.map((v) => {
            if (v.custom_id == action.custom_id) {
              return { ...v, ...action.payload };
            } else return v;
          }),
        };

        return itemTemp;
      case ACTIONS.CHANGEPUBLIC:
        let objectTemp = { ...state, ...action.payload };
        return objectTemp;
      case ACTIONS.CHANGERECI:
        let objectTempReci = {
          ...state,
          recipient_data: { ...state.recipient_data, ...action.payload },
        };
        return objectTempReci;
      case ACTIONS.PROPERTY:
        let stateItemTemp = {
          ...state,
          items: state?.items?.map((value) => {
            if (value?.custom_id == action?.custom_id) {
              return {
                ...value,
                product: {
                  ...value.product,
                  properties: value?.product?.properties?.map((val) => {
                    if (val.property_id == action.property_id) {
                      return { ...val, ...action.payload };
                    } else return val;
                  }),
                },
              };
            } else return value;
          }),
        };
        return stateItemTemp;
      case ACTIONS.SUBMIT:
        let productTemp = state?.items?.map((value) => {
          if (typeId == 1) {
            return {
              product_id: value?.id,
              count: value?.count,
              discount: value?.discount,
              price: value?.price,
              json: JSON.stringify(value?.product?.properties),
            };
          } else {
            return {
              product_id: value?.id,
              count: value?.count,
              discount: value?.discount,

              json: JSON.stringify(value?.product?.properties),
            };
          }
        });
        let payloadSubmit = {
          customer_id: state?.customer?.value ?? "",
          delivery_address: state?.recipient_data?.address ?? "",
          recipient_postalcode: state?.recipient_data?.postalCode ?? "",
          recipient_phone: state?.recipient_data?.mobile ?? "",
          recipient_name: state?.recipient_data?.fullname ?? "",
          tax: state?.tax ?? 0,
          order_date: state?.order_date ?? 0,
          description: state?.description ?? "",
          products: JSON.stringify(productTemp),
          type: typeId,
        };
        addOrderApi(payloadSubmit).then((res) => {
          if (res?.status == 1) {
            navigate("/new-order-list");

            if (res?.msg != undefined && res?.msg != null && res?.msg != "") {
              ToastCustomize({
                mainText: res.msg,
                duration: 3000,
                toastType: "success",
                color: "success",
                position: "top-center",
                hasHeader: false,
              });
            }
            return initialState;
          } else {
            if (res?.msg != undefined && res?.msg != null && res?.msg != "") {
              ToastCustomize({
                mainText: res.msg,
                duration: 3000,
                toastType: "danger",
                color: "danger",
                position: "top-center",
                hasHeader: false,
              });
            }
            return state;
          }
        });
      case ACTIONS.EDIT:
        let productEditTemp = state?.items?.map((value) => {
          if (typeId == 1) {
            return {
              product_id: value?.id,
              count: value?.count,
              discount: value?.discount,
              price: value?.price,
              json: JSON.stringify(value?.product?.properties),
            };
          } else {
            return {
              product_id: value?.id,
              count: value?.count,
              discount: value?.discount,

              json: JSON.stringify(value?.product?.properties),
            };
          }
        });
        let payloadEdit = {
          customer_id: state?.customer?.value ?? "",
          delivery_address: state?.recipient_data?.address ?? "",
          recipient_postalcode: state?.recipient_data?.postalCode ?? "",
          recipient_phone: state?.recipient_data?.mobile ?? "",
          recipient_name: state?.recipient_data?.fullname ?? "",
          tax: state?.tax ?? 0,
          order_date: state?.order_date ?? 0,
          description: state?.description ?? "",
          products: JSON.stringify(productEditTemp),
          type: typeId,
          order_id: orderId,
        };
        console.log("edit", payloadEdit, productEditTemp);
        editOrderApi(payloadEdit).then((res) => {
          if (res?.status == 1) {
            // navigate("/new-order-list");

            if (res?.msg != undefined && res?.msg != null && res?.msg != "") {
              ToastCustomize({
                mainText: res.msg,
                duration: 3000,
                toastType: "success",
                color: "success",
                position: "top-center",
                hasHeader: false,
              });
            }
            return initialState;
          } else {
            if (res?.msg != undefined && res?.msg != null && res?.msg != "") {
              ToastCustomize({
                mainText: res.msg,
                duration: 3000,
                toastType: "danger",
                color: "danger",
                position: "top-center",
                hasHeader: false,
              });
            }
            return state;
          }
        });
      case ACTIONS.REMOVE:
        let itemsTemp = {
          ...state,
          items: state.items.filter((value) => {
            if (value.custom_id != action.custom_id) {
              return value;
            }
          }),
        };
        return itemsTemp;
      case ACTIONS.SETEDITDATA:
        // console.log("dddddddddd", action.payload);

        let resultTemp = action.payload ?? [];
        resultTemp = {
          customer: {
            value: resultTemp?.id,
            label: `${
              resultTemp?.customer[0]?.corporate == 1
                ? `${resultTemp?.customer[0]?.company_name} (${resultTemp?.customer[0]?.firstname} ${resultTemp?.customer[0]?.lastname} - ${resultTemp?.customer[0]?.mobile})`
                : `${resultTemp?.customer[0]?.firstname} ${resultTemp?.customer[0]?.lastname} - ${resultTemp?.customer[0]?.mobile}`
            }`,
          },
          items: resultTemp?.order_items?.map((value, index) => {
            return {
              ...value,
              custom_id: index + 1,
              price: value?.price ?? 0,
              product: {
                cover_path: value?.product?.cover_path,
                ...value?.product[0],
                label: value?.product[0]?.title ?? "",
                value: value?.product[0]?.id,
                properties:
                  JSON.parse(
                    value?.json == "" ||
                      value?.json == undefined ||
                      value?.json == null
                      ? "[{}]"
                      : value?.json
                  ) ?? [],
              },
            };
          }),
          tax: resultTemp?.tax,
          description: resultTemp?.description,
          order_date: resultTemp?.order_date,
          recipient_data: {
            fullname: resultTemp?.recipient_name,
            mobile: resultTemp?.recipient_phone,
            postalCode: resultTemp?.recipient_postalcode,
            address: resultTemp?.delivery_address,
          },
        };
        return resultTemp;
      default:
        return state;
    }
  };
  const initialState = {
    customer: {},
    items: [],
    tax: "0",
    description: "",
    recipient_data: { fullname: "", mobile: "", address: "", postalCode: "" },
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  const [order, setOrder] = useState("add");
  const [customerListState, setCustomerListState] = useState([]);
  const [productListState, setProductListState] = useState([]);
  // customer modal state
  const [showModal, setShowModal] = useState(false);
  const [tagOption, setTagOption] = useState([]);
  const [userOption, setUserOption] = useState([]);
  const [bankName, setBankName] = useState([]);
  const [tagUpdater, setTagUpdater] = useState(false);
  const [loading, setLoading] = useState(false);

  // validation function
  const validation = () => {
    let validate = true;
    let itemsIdTemp = state?.items.filter(
      (v) =>
        v.id == -1 ||
        v.id == "" ||
        v.id == 0 ||
        v.id == undefined ||
        v.id == null
    );
    let itemWithoutPrice = state?.items?.filter((v) => v.call_price == false);
    let itemWithoutPriceEdit = state?.items?.filter((v) => v.price == 0);
    let itemWithoutCount = state?.items?.filter((v) => v.count == 0);
    let txt = "";
    if (
      state?.customer?.value == undefined ||
      state?.customer?.value == null ||
      state?.customer?.value == ""
    ) {
      validate = false;
      txt = "مشتری باید انتخاب شود.";
    } else if (itemsIdTemp.length != 0) {
      validate = false;
      txt = "تمامی آتیمها باید محصول مشخص داشته باشند.";
    } else if (
      (itemWithoutPrice.length > 0 && order == "add") ||
      (order == "edit" && itemWithoutPriceEdit.length > 0 && typeId == 1)
    ) {
      validate = false;
      txt = "قیمت محصولات باید مشخص باشد.";
    } else if (itemWithoutCount.length > 0) {
      validate = false;
      txt = "تعداد آیتمها را مشخص کنید.";
    } else if (
      state?.recipient_data?.fullname == "" ||
      state?.recipient_data?.mobile == "" ||
      state?.recipient_data?.address == ""
    ) {
      validate = false;
      txt = "اطلاعات گیرنده را کامل کنید.";
    } else if (!mobileChecker(state?.recipient_data?.mobile)) {
      validate = false;
      txt = "شماره تماس تحویل گیرنده صحیح نیست.";
    } else if (state?.recipient_data?.postalCode.length != 10) {
      validate = false;
      txt = "کدپستی وارد شده صحیح نیست.";
    }

    if (!validate) {
      ToastCustomize({
        mainText: txt,
        duration: 3000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
    }
    return validate;
  };
  const customerListFunc = (txt) => {
    customerListApi({
      page: 1,
      count: 100,
      keyword: txt,
    }).then((data) => {
      let customerListTemp = data?.result?.map((v) => {
        if (v.corporate == 1)
          return {
            label: `${v?.company_name} (${v?.firstname} ${v.lastname} - ${v?.mobile})`,
            value: v?.id,
          };
        else
          return {
            label: `${v?.firstname} ${v.lastname} - ${v?.mobile}`,
            value: v?.id,
          };
      });
      setCustomerListState(customerListTemp ?? []);
    });
  };
  const productListFunc = (txt) => {
    productListApi({
      page: 1,
      count: 100,
      title: txt,
      type: typeId == 1 ? 3 : 1,
    }).then((data) => {
      setProductListState(
        translateToReactSelect(false, data?.result, "title", true, "id") ?? []
      );
    });
  };
  const customerDebounce = debounce(customerListFunc, 1000);
  const productDebounce = debounce(productListFunc, 1000);

  useEffect(() => {
    getHashtag().then((result) => {
      setTagOption(translateToReactSelect(false, result, "text"));
    });
  }, [tagUpdater]);
  useEffect(() => {
    setLoading(true);
    async function loadPage() {
      await findUser().then((result) => {
        setUserOption(translateToReactSelect(false, result, "fullname", true));
      });
      await getConfig().then((result) => {
        setBankName(result.banks);
      });
      if (route.pathname.includes("edit") && orderId != undefined) {
        await getOrderApi({ order_id: orderId }).then((res) => {
          dispatch({
            type: ACTIONS.SETEDITDATA,
            payload: res?.result[0] ?? [],
          });
        });
      }
      setLoading(false);
      customerDebounce("");
      productDebounce("");
    }
    loadPage();
  }, []);
  useEffect(() => {
    if (route.pathname.includes("edit") && orderId != undefined)
      setOrder("edit");
    else setOrder("add");
  }, [route]);

  return loading ? (
    <Loader />
  ) : (
    <div className="mx-auto create-order-page-style" style={{ width: "95%" }}>
      <div className="d-flex flex-wrap align-items-end mb-4">
        <div className="mx-1" style={{ width: 300 }}>
          <ReactSelect
            title="انتخاب مشتری"
            itemsList={customerListState}
            inputValue={state?.customer}
            inputSize="lg"
            onChangeFunc={(e) =>
              dispatch({
                type: ACTIONS.CHANGEPUBLIC,
                payload: { customer: e },
              })
            }
            onInputChange={(value) => {
              customerDebounce(value);
            }}
          ></ReactSelect>
        </div>
        <div className="d-flex">
          <div className="mx-1 mb-1">
            <CustomButton
              size="medium"
              className=""
              onClick={() => {
                setShowModal(true);
              }}
              color="primary"
            >
              ساخت مشتری جدید
            </CustomButton>
          </div>
          <div className="mx-1 mb-1">
            <CustomButton
              size="medium"
              className=""
              onClick={() => {
                dispatch({ type: ACTIONS.ADD });
              }}
              color="primary"
            >
              افزودن آیتم سفارش
            </CustomButton>
          </div>
        </div>
      </div>
      {state?.items?.length > 0 && (
        <>
          <OrderPageContent
            orderData={state}
            dispatch={dispatch}
            ACTIONS={ACTIONS}
            productDebounce={productDebounce}
            productListState={productListState}
            order={order}
          />
          {order == "add" ? (
            <div className="mx-1 my-2 d-flex justify-content-end">
              <CustomButton
                size="medium"
                className=""
                onClick={() => {
                  if (validation()) dispatch({ type: ACTIONS.SUBMIT });
                }}
                color="success"
              >
                ثبت نهایی
              </CustomButton>
            </div>
          ) : (
            <div className="mx-1 my-2 d-flex justify-content-end">
              <CustomButton
                size="medium"
                className=""
                onClick={() => {
                  if (validation()) dispatch({ type: ACTIONS.EDIT });
                }}
                color="success"
              >
                ویرایش
              </CustomButton>
            </div>
          )}
        </>
      )}
      <AddEditCustomerModal
        show={showModal}
        setShow={setShowModal}
        type="add"
        headerText="ساخت مشتری جدید"
        data={{}}
        tagOption={tagOption}
        userOption={userOption}
        bankName={bankName}
        setCustomerUpdater={() => {}}
        setTagUpdater={setTagUpdater}
      />
    </div>
  );
}
